const isImage = (filename: string) => {
    let ext = filename;

    if (ext.includes(".")) {
        const parts = ext.split(".");
        ext = parts[parts.length - 1];
    }

    return /(jpg|jpeg|png|webp|avif|gif|svg)$/.test(ext);
};

export default isImage;
